import React from 'react'
import IntroSections from '../IntroSections'
import {initialCartItems, useCartContext} from '../context/CartContext'
import storeItems from "../data/StoreData.json";
import RowInCart from './RowinCart';
import FormatCurrency from "../Store/FormatCurrency";
import {Link} from 'react-router-dom';

const CartPage = () => {
    const {CartItems} = useCartContext();  
    
const total =  FormatCurrency(
        CartItems.reduce((total, cartItem) => {
        const item = storeItems.find((i) => i.id === cartItem.id);
        return total + (item?.price || 0) * cartItem.quantity ;
        }, 0)
    )
const Coupon =  FormatCurrency(
        CartItems.reduce((total, cartItem) => {
        const item = storeItems.find((i) => i.id === cartItem.id);
        return (total) + (item?.price   || 0)  * (cartItem.quantity) ;
        }, 0)
    ) 



    return (

        <>
        <IntroSections sectionName="Cart" sectionLink="Cart" />
<section className='CartPage'>

          
    <div className='container'>

   

    <table  className="table table-bordered text-center mt-3">
        <thead className="bg-dark text-light">
            <tr>
            <td>Product</td>
            <td>Product name</td>
            <td>Price</td>
            <td>Quantity</td>
            <td>Total</td>
            <td>Remove</td>     
            </tr>
             </thead>
                 {
    CartItems.map((item) => {    
     return(                 
         <tbody key={item.id} >
            <RowInCart {...item}/>  
    </tbody>   
        )})
              }  
             


        </table> 

               

    </div>     
</section>

            <section className='CART_SUBTOTAL_container'>

                
            <div className='container'>

                    <div className='row'>  
        <div className='col-lg-6'>
           
        <div className='CART_SUBTOTAL mt-5 pt-3'>
                <h3>CART SUBTOTAL</h3>           
             <table className="table table-bordered text-center mb-5">
                <tbody>
                    <tr>
                        <td>Order Subtotal</td>
                        <td>{total}</td>
                    </tr>
                    <tr>
                        <td>Shipping</td>
                        <td>Free Shipping</td>
                    </tr>

                    <tr>
                        <td>Coupon</td>
                        <td>$0</td>
                    </tr>

                    <tr>
                        <td>Total</td>
                    <td>{Coupon}</td>
                    </tr>
                </tbody>
            </table>
      
                            
             <Link  to="/Checkout"> Checkout Now </Link>
                   
</div>                           
</div>  
    </div> 
            </div>
            </section>
  </>
)
}

export default CartPage